import type {
  NotificationListResponseType,
  AnnouncementListResponseType,
} from "@sellar-io/api-v2/types";
import {
  DIRECT_MESSAGE,
  ORDER_DETAILS,
  ORDER_BUYER,
  NOTIFICATIONS,
  ORDER_COMMENT,
  SELLAR_CREDIT_TAB,
} from "../../constants/routes";

const getSellarCreditNavigationUrl = (
  notification: NotificationListResponseType[number],
) => {
  switch (notification.subtype) {
    case "sellar_credit_low_balance":
      return SELLAR_CREDIT_TAB;
    case "sellar_credit_offer_expiry":
      return `${ORDER_DETAILS.href({ orderId: notification.entityId })}?tab=All+orders`;
    default:
      return NOTIFICATIONS;
  }
};

const getOrderNavigationUrl = (
  notification: NotificationListResponseType[number],
) => {
  switch (notification.subtype) {
    case "order_comment_added":
      return ORDER_COMMENT.href({ orderId: notification.entityId });
    default:
      return `${ORDER_DETAILS.href({ orderId: notification.entityId })}?tab=All+orders`;
  }
};

export const getNotificationNavigationUrl = (
  notification: NotificationListResponseType[number],
) => {
  switch (notification.type) {
    case "message":
      return DIRECT_MESSAGE.href({ relationshipId: notification.entityId });
    case "order":
      return getOrderNavigationUrl(notification);
    case "storefront":
      return `${ORDER_BUYER.href({ supplierIdOrUrlId: notification.SenderBusiness.urlId ?? "" })}`;
    case "sellar_credit":
      return getSellarCreditNavigationUrl(notification);
    default:
      return NOTIFICATIONS;
  }
};

export const getAnnouncementNavigationUrl = (
  announcement: AnnouncementListResponseType[number],
) => {
  const supplierUrlId = announcement.SenderBusiness.Supplier?.urlId;
  if (!supplierUrlId) {
    return NOTIFICATIONS;
  }
  return `${ORDER_BUYER.href({ supplierIdOrUrlId: supplierUrlId })}?categoryId=${announcement.Product.ParentId}`;
};
